import React from 'react';
import useGetDocumentsMetaData from '@data/documentSignedUrl/hooks/useGetDocumentsMetaData';
import { useGetDocumentBySignedUrl } from '@data/document/hooks/useGetDocumentBySignedUrl/useGetDocumentBySignedUrl';

export const useGetSignedUrlAndGetDoc = () => {
	const getDocMetaData = useGetDocumentsMetaData();
	const getDocBySignedUrl = useGetDocumentBySignedUrl();

	return React.useCallback((documentId: string | undefined, onSuccess: (doc: Blob) => void) => {
		if (!documentId) { return; }
		getDocMetaData({
			data: {
				ids: [documentId],
				withSignedUrl: true,
			},
			onSuccess: (metaDataRes) => {
				const docMetaData = metaDataRes?.data?.data[0];
				if (!docMetaData) { return; }
				const { signedUrl, identifier } = docMetaData;
				if (!signedUrl || !identifier) { return; }
				getDocBySignedUrl({
					id: documentId,
					identifier: identifier,
					signedUrl: signedUrl,
					onSuccess,
				});
			},
		});
	}, [getDocBySignedUrl, getDocMetaData]);
};
